import React, { useEffect } from "react";
import AttendanceDashboardWrapper from "../components/AttendanceWrapper";
import { useDispatch } from "react-redux";
import AwardsMain from "./AwardsMain";

const Devices = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: "SIDEBAR", num: "8" });
  }, []);

  return (
    <AttendanceDashboardWrapper>
      <AwardsMain />
    </AttendanceDashboardWrapper>
  );
};

export default Devices;
